<!--
共通ヘッダーコンポーネント
TODO: PZとFLP共通で使えるようにしたい
-->
<template>
    <header class="siteID">
        <img src="https://auth2.jleague.jp/img/logo.png" id="logo" alt="J.LEAGUE">
    </header>
</template>

<script>
export default {
    name: 'JleagueHeader',
}
</script>
